// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  min-height: calc(100vh - 200px);
  padding: 60px 0;
}
.page-container .section-padding {
  padding: 80px 0;
  margin-bottom: 20px;
}
.page-container .container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 15px;
}
.page-container h1 {
  color: #090f01;
  font-size: 36px;
  margin-bottom: 30px;
  font-weight: 700;
}
.page-container .under-construction {
  width: 300px;
  padding: 20px;
  text-align: center;
  border: 2px solid #333;
  font-size: 20px;
  font-weight: bold;
  margin: 60px auto;
  border-radius: 6px;
}
.page-container h2 {
  margin-bottom: 40px;
}
.page-container p {
  font-size: 16px;
  line-height: 1.8;
  color: #212121;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .page-container .section-padding {
    padding: 60px 0;
    margin-bottom: 15px;
  }
  .page-container h1 {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .page-container h2 {
    margin-bottom: 20px;
  }
}
.contact-section {
  background: #f8f8f8;
  padding: 40px 0;
  margin-top: 40px;
  border-top: 1px solid #ddd;
}
.contact-section .container {
  text-align: center;
}
.contact-section .contact-email {
  font-size: 16px;
  color: #212121;
  margin: 0;
  font-weight: 600;
}
.contact-section .contact-email a {
  color: #CFAB8D;
  text-decoration: none;
  transition: all 0.3s ease;
}
.contact-section .contact-email a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .page-container {
    padding: 30px 0;
  }
  .page-container .section-padding {
    padding: 40px 0;
    margin-bottom: 10px;
  }
  .page-container h1 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  .page-container h2 {
    font-size: 20px;
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/home.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,mBAAA;AACJ;AAEE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AALJ;;AASA;EAEI;IACE,eAAA;IACA,mBAAA;EAPJ;EAUE;IACE,eAAA;IACA,mBAAA;EARJ;EAWE;IACE,mBAAA;EATJ;AACF;AAaA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAXF;AAaE;EACE,kBAAA;AAXJ;AAcE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAZJ;AAcI;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AAZN;AAcM;EACE,0BAAA;AAZR;;AAkBA;EACE;IACE,eAAA;EAfF;EAiBE;IACE,eAAA;IACA,mBAAA;EAfJ;EAkBE;IACE,eAAA;IACA,mBAAA;EAhBJ;EAmBE;IACE,eAAA;IACA,mBAAA;EAjBJ;AACF","sourcesContent":[".page-container {\n  min-height: calc(100vh - 200px);\n  padding: 60px 0;\n\n  .section-padding {\n    padding: 80px 0;\n    margin-bottom: 20px;\n  }\n\n  .container {\n    max-width: 1140px;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n\n  h1 {\n    color: #090f01;\n    font-size: 36px;\n    margin-bottom: 30px;\n    font-weight: 700;\n  }\n\n  .under-construction {\n    width: 300px;\n    padding: 20px;\n    text-align: center;\n    border: 2px solid #333;\n    font-size: 20px;\n    font-weight: bold;\n    margin: 60px auto;\n    border-radius: 6px;\n  }\n\n\n  h2 {\n    margin-bottom: 40px;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 1.8;\n    color: #212121;\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-container {\n    .section-padding {\n      padding: 60px 0;\n      margin-bottom: 15px;\n    }\n\n    h1 {\n      font-size: 28px;\n      margin-bottom: 20px;\n    }\n\n    h2 {\n      margin-bottom: 20px;\n    }\n  }\n}\n\n.contact-section {\n  background: #f8f8f8;\n  padding: 40px 0;\n  margin-top: 40px;\n  border-top: 1px solid #ddd;\n\n  .container {\n    text-align: center;\n  }\n\n  .contact-email {\n    font-size: 16px;\n    color: #212121;\n    margin: 0;\n    font-weight: 600;\n\n    a {\n      color: #CFAB8D;\n      text-decoration: none;\n      transition: all 0.3s ease;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .page-container {\n    padding: 30px 0;\n\n    .section-padding {\n      padding: 40px 0;\n      margin-bottom: 10px;\n    }\n\n    h1 {\n      font-size: 24px;\n      margin-bottom: 15px;\n    }\n\n    h2 {\n      font-size: 20px;\n      margin-bottom: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
